const REASONS = [
  {
    icon: 'ri-earth-line',
    title: 'Boundless Global Reach',
    desc: 'No matter where you are starting or heading, our worldwide service network ensures a seamless experience across borders.',
    tag: '190+ clients',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'All-In-One Convenience',
    desc: 'We align your custom tours, flights, international hotels, and visas into one cohesive, stress-free travel plan.',
    tag: 'One plan, zero hassle',
  },
  {
    icon: 'ri-time-line',
    title: 'Always-On Support, Every Time Zone',
    desc: 'Travel does not sleep, and neither do we. Our dedicated team is on hand to assist with last-minute bookings and itinerary changes — whenever you need us.',
    tag: 'Always on call',
  },
];

export default function WhyChoose() {
  return (
    <section className="relative w-full bg-primary-950 py-20 md:py-28" id="why">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {/* Left: heading */}
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-accent-300">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
              Why Choose GlobeSync
            </span>
            <h2 className="mt-3 font-heading text-3xl font-bold leading-tight tracking-tight text-background-50 md:text-5xl">
              Why Choose Our Kochi-Based
              <span className="text-accent-300"> Travel Agency?</span>
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-background-100/80">
              We built GlobeSync around one idea: global travel should feel simple,
              safe, and supported — in every time zone.
            </p>

            <a
              href="#contact"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              Plan my trip
              <i className="ri-arrow-right-line text-lg" />
            </a>
          </div>

          {/* Right: reasons */}
          <div className="flex flex-col gap-4 lg:col-span-7">
            {REASONS.map((r, i) => (
              <article
                key={r.title}
                className="group flex flex-col gap-4 rounded-2xl border border-background-50/10 bg-background-50/5 p-6 transition-colors hover:bg-background-50/10 sm:flex-row sm:items-center sm:gap-6 md:p-7"
              >
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${r.icon} text-2xl`} />
                </div>
                <div className="flex-1">
                  <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
                    <h3 className="font-heading text-lg font-bold text-background-50 md:text-xl">
                      {r.title}
                    </h3>
                    <span className="mt-1 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-200 sm:mt-0">
                      {r.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-background-100/75">
                    {r.desc}
                  </p>
                </div>
                <span className="hidden font-heading text-4xl font-bold text-background-50/10 sm:block">
                  {String(i + 1).padStart(2, '0')}
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}